import { FontFamilySwitch } from "../../utils/font"

export const DateStyle = {
  text: {
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().medium,
    [`& fieldset`]: {
      borderRadius: '8px',
      border: ` 1px solid #E4E8EE !important`,
      backgroundColor: "#fff",
    },
    width: '100%',
    "& .MuiOutlinedInput-root": {
      "& .MuiTextField-root": {
        width: '100%',
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().medium,
      },
      "&.Mui-focused fieldset": {
        border: "2px solid #1F74EA !important",
      },
      "& .MuiInputBase-root-MuiOutlinedInput-root": {
        height: "58px",
        width: "inherit",
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().medium,
      },
      "& .MuiInputAdornment-root": {
        zIndex: 1,
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().medium,
      },
      "&:hover fieldset": {
        borderColor: "#E4E8EE",
      },
      "& .MuiOutlinedInput-input.MuiInputBase-input": {
        zIndex: 1,
        padding: '12.5px 6px',
        width: '100%',
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().medium,
      },
    },
  }
};
